module.exports = __webpack_public_path__ + "static/media/bindu.29665b75.jpg";